import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LoadingSpinner({ message }) {
  const { t } = useTranslation();
  return (
    <div className="spinner-container">
      <div className="result-container">
        <div className="spinner" aria-hidden="true" />
        <p
          style={{ marginLeft: '10px' }}
          role="status"
          aria-live="polite"
          aria-atomic="true"
        >
          {message}
        </p>
      </div>
      <p aria-live="polite" aria-atomic="true">{t('loadingSpinner.waitNotice')}</p>
    </div>
  );
}
